
import {throwError as observableThrowError, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {TaxplanIQServices} from "./TaxplanIQServices";
import {PATH, SOURCE_TYPE} from "../constants/Tpiq.constants";

export function getPaginatedToDosUrl(org, userId, channelType, channelId, status) {
    return `/TaxPlanningServices/orgs/${org}/users/${userId}/channels/${channelType}/${channelId}/toDos/list?status=${status}`;
}

export function getClientAppPaginatedToDosUrl(org, userId, status, clientInfo,planId, year) {
  let url = `/TaxPlanningServices/users/${userId}/orgs/${org}/toDos/list?status=${status}`;
  if (clientInfo && clientInfo.qountClientId) {
    url += `&clientId=${clientInfo.qountClientId}`;
  }
  if(planId){
    url += `&planId=${planId}`;
  }
  if(year){
    url += `&year=${year}`;
  }
  return url;
}

export function getToDosUrl(org, userId, channelType, channelId) {
    return `/TaxPlanningServices/orgs/${org}/users/${userId}/channels/${channelType}/${channelId}/toDos`;
}

export function getToDoWithPostUrl(userId, org, todoId, withPost) {
    return `/TaxPlanningServices/users/${userId}/orgs/${org}/toDos/${todoId}/?withPost=${withPost}`;
}

export function getFirmTodosTableDataUrl(org, userId) {
    return `/TaxPlanningServices/orgs/${org}/users/${userId}/toDos`;
}

export function getUpdateTodoSingleStatus(userId, org, clientId, todoId) {
    return `/TaxPlanningServices/users/${userId}/orgs/${org}/clients/${clientId}/toDos/${todoId}`;
}

export function getToDosUrlWithOutPost(org, userId, todoId) {
    let url =  `/TaxPlanningServices/users/${userId}/orgs/${org}/toDos/${todoId}`;
    return url + '?withPost=false';
}

export function getUpdateToDoDataUrl(org, userId, clientId, todoId) {
    return `/TaxPlanningServices/orgs/${org}/users/${userId}/clients/${clientId}/toDos/${todoId}`;
}

export function getRemoveToDosUrl(org, userId, clientId, todoId) {
    return `/TaxPlanningServices/orgs/${org}/users/${userId}/clients/${clientId}/toDos/${todoId}`;
}


@Injectable({
  providedIn: 'root'
})
export class TodoServices extends  TaxplanIQServices {
    constructor(http: HttpClient) {
        super(http);
    }

    getAllTodosTableData(org, userId, channelType, channelId, status, data, type?, clientInfo?, planId?,year?): Observable<any> {
        let url = '';
        if (type === 'all') {
             url = getClientAppPaginatedToDosUrl(org, userId, status, clientInfo,planId,year);
        } else {
             url = getPaginatedToDosUrl(org, userId, channelType, channelId, status);
             if (channelType === 'companies') {
                url = `${url}&view=all`;
            }
        }
        return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    addToDo(org, userId, channelType, channelId, data): Observable<any> {
        const url = getToDosUrl(org, userId, channelType, channelId);
        return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    updateToDo(org, userId, channelType, channelId, data): Observable<any> {
        let url = getToDosUrl(org, userId, channelType, channelId);
        url = `${url}/${data.id}`;
        return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    removeToDo(org, userId, channelId, todoId): Observable<any> {
        let url = getRemoveToDosUrl(org, userId, channelId, todoId);
        // url = `${url}/${todoId}`;
        return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    getToDo(org, userId, todoId): Observable<any> {
        let url = getToDosUrlWithOutPost(org, userId, todoId);
        return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    getTodoTableData(user, org, todoId, withPost): Observable<any> {
        const url = getToDoWithPostUrl(user, org, todoId, withPost);
        return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    updateTodoStatusOrder(user, org, clientId, data): Observable<any> {
        const url = getUpdateTodoSingleStatus(user, org, clientId, data.id);
        // const url = this.interpolateUrl(PATH.UPDATE_TODO_SERVICE, null, {userId: user, org, clientId, todoId: data.id});
        return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    updateSinglePageTodo(org, user, taskId, data): Observable<any> {
        const url = this.interpolateUrl(PATH.ADD_SINGLEPAGE_TODO, null, {org, userId: user, taskId});
        return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    getFirmTodosTableData(org, userId, data): Observable<any> {
        const url = getFirmTodosTableDataUrl(org, userId);
        return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    getFirmTodosCount(org, userId, data): Observable<any> {
        let url = getFirmTodosTableDataUrl(org, userId);
        url = url + '/count';
        return this.create(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    updateFirmTodoData(org, userId, data): Observable<any> {
        let url = getFirmTodosTableDataUrl(org, userId);
        url = url + '/table-update';
        return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    updateTodoData(org, userId, clientId, data): Observable<any> {
        let url = getUpdateToDoDataUrl(org, userId, clientId, data.id);
        return this.update(url, data, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
    return observableThrowError(error.error);
  }
}
